<template>
  <Modal
    class="cc-modal"
    width="1100"
    footer-hide
    v-model="visibility"
    title="PUSH-接收域名"
  >
    <div class="content" v-if="data">
      <Table class="domain-table" :columns="columns" :data="data">
        <template slot="remark" slot-scope="{ row }">
          <Button @click="onShowRemark(row.remark)">查看备注</Button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button type="primary" @click="onSelectTemplate(row)">{{
            !templateInfo.id ? "选择模板" : templateInfo.name
          }}</Button>
        </template>
      </Table>
      <div style="line-height: 80px">
        如果您选择使用临时模板，请阅读
        <span
          style="color: #2d8cf0; cursor: pointer"
          @click="templateRulesModel"
          >《域名管理系统域名模板服务协议》</span
        >
      </div>
      <div v-if="data[0] && data[0].isLock === 1" class="tips-warn">
        <img class="icon" src="@/assets/image/tips-warn1.png" />
        温馨提示：此域名已设置60天内禁止转移，请知悉！
      </div>
      <Form label-position="top">
        <FormItem label="验证码" style="width: 430px" required>
          <template>
            <div class="row">
              <Input
                class="height45"
                v-model.trim="form.vCode"
                placeholder="请填写验证码"
                style="width: 120px"
                clearable
              ></Input>
              <div class="row" style="margin-left: 30px">
                <identify
                  :identify-code="identifyCode"
                  :content-height="45"
                  @reloadEvent="reloadCodeEvent"
                />
                <div
                  style="margin-left: 10px; cursor: pointer"
                  @click="reloadCodeEvent"
                >
                  刷新
                </div>
              </div>
            </div>
          </template>
        </FormItem>
        <div v-if="checkType == 0" class="u-col">
          <FormItem class="cc-form-item" label="手机号码" required>
            <template>
              <div class="row">
                <Input
                  class="height45"
                  disabled
                  v-model.trim="user.mobile"
                  placeholder="请填写手机号码"
                  style="width: 150px"
                  clearable
                ></Input>
                <smsBtn
                  ref="smsBtn"
                  height="45px"
                  shape=""
                  @tap="getCodeEvent"
                  style="width: 120px; margin-left: 30px"
                ></smsBtn>
                <div v-if="user.email && user.email.length > 0 && !codeDisabled"
                    style="margin-left: 10px; cursor: pointer"
                    @click="checkType = 1"
                >
                  邮箱验证
                </div>
              </div>
            </template>
          </FormItem>
        </div>
        <div v-if="checkType == 1" class="u-col">
          <FormItem class="cc-form-item" label="邮箱" required>
            <template>
              <div class="row">
                <Input
                    class="height45"
                    disabled
                    v-model.trim="user.email"
                    placeholder="请填写邮箱"
                    style="width: 150px"
                    clearable
                ></Input>
                <smsBtn
                    ref="smsBtn"
                    height="45px"
                    shape=""
                    @tap="getCodeEvent"
                    style="width: 120px; margin-left: 30px"
                ></smsBtn>
                <div v-if="user.mobile && user.mobile.length > 0 && !codeDisabled"
                    style="margin-left: 10px; cursor: pointer"
                    @click="checkType = 0"
                >
                  手机验证
                </div>
              </div>
            </template>
          </FormItem>
        </div>
        <FormItem :label="checkType == 0 ? '短信验证码' : '邮箱验证码'" style="width: 430px" required>
          <Input
            class="height45"
            v-model.trim="form.code"
            :placeholder="checkType == 0 ? '请填写短信验证码' : '请填写邮箱验证码'"
            style="width: 150px"
            clearable
            @on-keyup="form.code = form.code.replace(/[^\d]/g, '')"
          ></Input>
        </FormItem>
        <div class="row">
          <Checkbox v-model="single"> 我已同意并阅读</Checkbox>
          <span style="color: #1c9cdf; cursor: pointer" @click="pushModel"
            >《域名管理系统域名push服务协议》</span
          >
        </div>
      </Form>
    </div>
    <div class="foot">
      <Button
        @click="onConfirm"
        type="primary"
        style="margin-right: 20px"
        :loading="loading"
        >确认PUSH</Button
      >
      <Button @click="onCancel">取消</Button>
    </div>
    <!-- 选择模板 -->
    <templateListModal
      :show.sync="templateListModalVisibility"
      @onChecked="checkedTemplate"
    ></templateListModal>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
    <!-- 域名管理系统域名push服务协议 -->
    <rule-modal
      :show.sync="pushRulesModelShow"
      :content="pushRulesContent"
      :title="pushRulesTitle"
    ></rule-modal>
    <!-- 模板协议 -->
    <rule-modal
      :show.sync="templateRulesModelShow"
      :content="templateRulesContent"
      :title="templateRulesTitle"
    ></rule-modal>
  </Modal>
</template>
<script>
import templateListModal from "components/template/templateListModal.vue";
import pushRemarkModal from "components/push/pushRemarkModal.vue";
import { makeCode } from "utils/identify";
import identify from "components/identify.vue";
import smsBtn from "components/smsBtn.vue";
import { smsSend } from "api/customer.js";
import { pushEdit } from "api/domain.js";
import { mapState } from "vuex";
import ruleModal from "components/ruleModal.vue";
import pushRules from "assets/rule/pushRules";
import templateRules from "assets/rule/templateRules";
export default {
  name: "pushReceiveDomainModal",
  components: {
    templateListModal,
    pushRemarkModal,
    identify,
    smsBtn,
    ruleModal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        {
          title: "域名",
          align: "center",
          key: "ym",
        },
        {
          title: "对方ID",
          align: "center",
          key: "sender",
        },
        {
          title: "模板",
          align: "center",
          slot: "action",
        },
        {
          title: "索要金额",
          align: "center",
          key: "amount",
        },
        {
          width: 180,
          title: "时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "备注",
          align: "center",
          slot: "remark",
        },
      ],
      // 选择模板
      templateListModalVisibility: false,
      templateInfo: {},
      // 备注
      pushRemarkModalVisibility: false,
      remark: "",
      // 提交信息
      identifyCode: "",
      form: {
        vCode: "",
        code: "",
        domainPushId: "",
      },
      single: false,
      loading: false,
      // 域名管理系统域名push服务协议
      pushRulesModelShow: false,
      pushRulesContent: "",
      pushRulesTitle: "",
      // 模板协议
      templateRulesModelShow: false,
      templateRulesContent: "",
      templateRulesTitle: "",
      checkType: 0,
      codeDisabled: false
    };
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.identifyCode = makeCode();
          this.codeDisabled = false;
          this.form.vCode = "";
          this.$refs.smsBtn && this.$refs.smsBtn.reset();
        }
      },
    },
  },
  computed: {
    ...mapState(["user"]),
    visibility: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  created() {
    if (this.user.mobile != null && this.user.mobile.length > 0) {
      this.checkType = 0
    } else {
      this.checkType = 1
    }
  },
  methods: {
    // 域名管理系统域名push服务协议
    pushModel() {
      this.pushRulesModelShow = true;
      if (!this.pushRulesContent) {
        this.pushRulesContent = pushRules.content;
        this.pushRulesTitle = pushRules.title;
      }
    },
    // 模板协议
    templateRulesModel() {
      this.templateRulesModelShow = true;
      if (!this.templateRulesContent) {
        this.templateRulesContent = templateRules.content;
        this.templateRulesTitle = templateRules.title;
      }
    },
    onCancel() {
      this.visibility = false;
    },
    // 确认PUSH
    async onConfirm() {
      try {
        if (!this.templateInfo.id) {
          this.$Message.warning("请选择域名模板！");
          return false;
        }
        if (!this.form.vCode) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
        if (this.form.vCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
          this.$Message.warning("请输入正确验证码！");
          return false;
        }
        if (!this.form.code) {
          this.$Message.warning("请输入验证码！");
          return false;
        }
        const res = await pushEdit({
          id: this.data[0].id,
          status: 1,
          templateId: this.templateInfo.id,
          code: this.form.code,
          checkType: this.checkType,
        });
        if (res.code === 200) {
          this.$Message.success("操作成功!");
          this.$emit("onReceive");
          this.onCancel()
        } else {
          this.$Message.warning("操作失败，稍后重试!");
        }
        this.$refs.smsBtn.reset();
      } catch (error) {
        console.log(error);
        this.$refs.smsBtn.reset();
      }
    },
    // 选择模板
    onSelectTemplate() {
      this.templateListModalVisibility = true;
    },
    // 确认模板
    checkedTemplate(val) {
      console.log(val)
      this.templateInfo = val;
      this.templateListModalVisibility = false;
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
    // 刷新图形验证码
    reloadCodeEvent() {
      this.identifyCode = makeCode();
    },
    // 获取验证码
    getCodeEvent(callback) {
      if (!this.form.vCode) {
        this.$Message.warning("请输入验证码！");
        this.$refs.smsBtn.reset();
        return false;
      }
      if (this.form.vCode.toLowerCase() !== this.identifyCode.toLowerCase()) {
        this.$Message.warning("请输入正确验证码！");
        return false;
      }
      smsSend(this.checkType)
        .then((res) => {
          if (res.code === 200 && res.result) {
            this.codeDisabled = true;
            callback(true);
          }
        })
        .catch(() => {
          this.codeDisabled = false;
          this.$refs.smsBtn.reset();
        });
    },
  },
};
</script>
<style lang="less" scoped>
.cc-modal {
  .content {
    padding: 0 30px;
    height: auto;
    min-height: 100px;
    max-height: 500px;
    overflow: auto;
  }
  .foot {
    border-top: 1px solid #dcdee2;
    padding-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
.row {
  display: flex;
  line-height: 40px;
  .name {
    min-width: 120px;
    text-align: right;
    margin-right: 20px;
  }
}
.tips-warn {
  margin: 10px 0;
  padding: 10px 50px;
  border-radius: 8px;
  color: #3892ea;
  font-size: 14px;
  background-color: #e9effd;
  border: 1px solid #3892ea;
  display: flex;
  align-items: center;
  .icon {
    margin-right: 20px;
    width: 20px;
    height: 19px;
  }
}
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 45px;
  }
  .ivu-input-prefix {
    width: 45px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
}
</style>
